import { useQuery } from '@tanstack/react-query';
import type { PharmacyPagedListResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSearchPharmacies, type SearchPharmaciesInput } from '../api/searchPharmacies.js';
import { rxKeys } from './keys.js';

export function searchPharmaciesQueryDefinition(input: SearchPharmaciesInput) {
  return {
    queryKey: rxKeys.pharmaciesSearch(input),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSearchPharmacies(input, signal),
  } as const;
}

export function useSearchPharmaciesQuery(input: SearchPharmaciesInput | undefined) {
  const enabled = Boolean(input && (input.name?.trim() ?? '') !== '');

  return useQuery({
    queryKey: input ? rxKeys.pharmaciesSearch(input) : (['rx', 'pharmacy', 'search', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<PharmacyPagedListResponseT> => {
      if (!input) {
        throw new Error('Missing pharmacy search input');
      }
      return fetchSearchPharmacies(input, signal);
    },
    enabled,
  });
}
